/**
 * @generated SignedSource<<1c7e2a77609e2f6726a5b2356ed5db90>>
 * @relayHash e27f52e112edeb3b92e0bb556cb358f4
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c214fac0044174efd2213bfd2d0629521038feb7851b24d230284ea576121378

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type GuildDonationScreenContentCreateDlocalGoMutation$variables = {
  amount: number;
  guildId: string;
};
export type GuildDonationScreenContentCreateDlocalGoMutation$data = {
  readonly createDlocalGoDonation: {
    readonly orderId: string;
    readonly redirectUrl: string;
  };
};
export type GuildDonationScreenContentCreateDlocalGoMutation = {
  response: GuildDonationScreenContentCreateDlocalGoMutation$data;
  variables: GuildDonationScreenContentCreateDlocalGoMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "amount"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "guildId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "amount",
        "variableName": "amount"
      },
      {
        "kind": "Variable",
        "name": "guildId",
        "variableName": "guildId"
      }
    ],
    "concreteType": "CreateDlocalGoDonationPayload",
    "kind": "LinkedField",
    "name": "createDlocalGoDonation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "orderId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "redirectUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "GuildDonationScreenContentCreateDlocalGoMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "GuildDonationScreenContentCreateDlocalGoMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "c214fac0044174efd2213bfd2d0629521038feb7851b24d230284ea576121378",
    "metadata": {},
    "name": "GuildDonationScreenContentCreateDlocalGoMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "42f35d3b0ab5da8af6235cb928422b80";

export default node;
